@if (canShow) {
  <button
    mat-menu-item
    (click)="onTransfer()"
    >
    <mat-icon>swap_horiz</mat-icon>
    <span>Transfer Master Suite</span>
  </button>
}
